import angular from 'angular';
import {
  amDataService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-finding-document-dialog.controller';
import template from './edit-finding-document-dialog.html';
import amFindingDocumentNameMessagesTpl from './messages/am-finding-document.name.messages.html';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';

class dialogService {
  getOptions($event, {
    findingId,
    document
  }) {
    return {
      controller,
      controllerAs: 'editFindingDocumentDialogVM',
      locals: {
        findingId,
        document,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.am.editFindingDocumentDialog', [
  alerts,
  amDataService,
  ngFileUpload,
  ssDialogService,
])
  .service('editFindingDocumentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('am-finding-document.name.messages.html', amFindingDocumentNameMessagesTpl);
  })
  .name;
